
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import IconOeamtcClose from '@components/icons/icon-oeamtc-close.svg';
import IconEdit from '@components/icons/icon-edit.svg';
import IconCheck from '@components/icons/icon-check.svg';
import TripDetailFooterButton from '@components/trip-detail/trip-detail/TripDetailFooterButton.vue';
import { scrollIntoPage } from '@util/scrollUtils';

@Component({
  name: 'TripDetailFooter',
  components: {
    TripDetailFooterButton,
    IconOeamtcClose,
    IconEdit,
    IconCheck
  }
})
export default class TripDetailFooter extends Vue {
  @Prop({ required: false })
  private errorMessage: string;

  @Prop({ default: false })
  private editMode: boolean;

  @Prop({ default: false })
  private addMode: boolean;

  @Prop({ default: false })
  private errorExists: boolean;

  @Prop({ default: false })
  private saveCancelDisabled: boolean;

  @Prop({ default: false })
  private deleteDisabled: boolean;

  @Prop({ default: false })
  private addAnotherDisabled: boolean;

  @Prop()
  private addAnotherTripChecked: boolean;

  private deleteTrip() {
    this.$emit('deleteTrip');
  }

  private editTrip() {
    this.$emit('editMode');
    scrollIntoPage()
  }

  private cancel() {
    this.$emit('cancel');
  }

  private save() {
    this.$emit('save');
  }
}
